import { useEffect, useState } from "react";
/** Grenzen aus dem Entwurf. Bewusst Zahlen statt Gerätenamen — sie gelten auch für Fenster. */
export const BREAKPOINT_TABLET = 744;
export const BREAKPOINT_DESKTOP = 1280;
export function classifyWidth(breite) {
    if (breite >= BREAKPOINT_DESKTOP)
        return "desktop";
    if (breite >= BREAKPOINT_TABLET)
        return "tablet";
    return "phone";
}
/**
 * Rohe Fensterbreite in Pixeln — die Grundlage von `useSizeClass`. Die Überlagerungsschwelle
 * innerhalb der Klasse „tablet" misst seit ME-Etappe 2 `me-spalten` selbst
 * (KONTEXT_SCHWELLE in MeSchale.tsx).
 */
export function useWindowWidth() {
    const [breite, setBreite] = useState(() => typeof window === "undefined" ? BREAKPOINT_DESKTOP : window.innerWidth);
    useEffect(() => {
        const beiAenderung = () => setBreite(window.innerWidth);
        beiAenderung();
        window.addEventListener("resize", beiAenderung);
        return () => window.removeEventListener("resize", beiAenderung);
    }, []);
    return breite;
}
export function useSizeClass() {
    return classifyWidth(useWindowWidth());
}
//# sourceMappingURL=useSizeClass.js.map